import { __extends, __values } from 'tslib';
import { Subject } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { animate, AnimationBuilder, style } from '@angular/animations';
import { Input, TemplateRef, ViewChild, Injectable, NgModule, Directive, ElementRef, HostListener, HostBinding, Renderer2, ViewContainerRef, Component, ContentChildren, Output, ViewChildren, EventEmitter, defineInjectable } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';
import { EffectsModule } from '@ngrx/effects';
import { ApiResolverService, ApiResolverModule } from '@kissmybutton/nsx-ui-api-lib';
import { AppSelectors, AppDispatchers, NsxUiEffects } from '@kissmybutton/nsx-ui-state-lib';
export { appConfigReducers } from '@kissmybutton/nsx-ui-state-lib';
import { topNComponentSelector } from '@kissmybutton/nsx-ui-common-lib';
export { EEndpointTypes } from '@kissmybutton/nsx-ui-common-lib';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NsxApiComponent = /** @class */ (function () {
    function NsxApiComponent() {
    }
    NsxApiComponent.propDecorators = {
        endpointType: [{ type: Input }],
        interval: [{ type: Input }]
    };
    return NsxApiComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NsxUiComponent = /** @class */ (function (_super) {
    __extends(NsxUiComponent, _super);
    function NsxUiComponent(appDispatchers) {
        var _this = _super.call(this) || this;
        _this.appDispatchers = appDispatchers;
        _this.isVisible = true;
        return _this;
    }
    /**
     * @param {?} visible
     * @return {?}
     */
    NsxUiComponent.prototype.setVisibility = /**
     * @param {?} visible
     * @return {?}
     */
    function (visible) {
        if (!visible && this.isVisible && this.pollingInterval) {
            this.appDispatchers.stopPolling(this.componentGuid);
        }
        else if (visible && !this.isVisible && this.pollingInterval) {
            this.appDispatchers.restartPolling(this.componentGuid);
        }
        this.isVisible = visible;
    };
    NsxUiComponent.propDecorators = {
        tpl: [{ type: ViewChild, args: [TemplateRef,] }],
        pollingInterval: [{ type: Input }]
    };
    return NsxUiComponent;
}(NsxApiComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TooltipService = /** @class */ (function () {
    function TooltipService() {
        this.tooltipPerFeature = {};
        this.newTooltip$ = new Subject();
    }
    /**
     * @param {?} feature
     * @param {?} template
     * @return {?}
     */
    TooltipService.prototype.setTooltip = /**
     * @param {?} feature
     * @param {?} template
     * @return {?}
     */
    function (feature, template) {
        this.tooltipPerFeature[feature] = template;
        this.newTooltip$.next();
    };
    /**
     * @param {?} feature
     * @return {?}
     */
    TooltipService.prototype.getTooltip = /**
     * @param {?} feature
     * @return {?}
     */
    function (feature) {
        return this.tooltipPerFeature[feature];
    };
    TooltipService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ TooltipService.ngInjectableDef = defineInjectable({ factory: function TooltipService_Factory() { return new TooltipService(); }, token: TooltipService, providedIn: "root" });
    return TooltipService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TooltipTemplateDirective = /** @class */ (function () {
    function TooltipTemplateDirective(tooltipService) {
        this.tooltipService = tooltipService;
    }
    /**
     * @return {?}
     */
    TooltipTemplateDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.tooltipService.setTooltip(this.nsxTooltipRef, this.nsxTooltipTemplate);
    };
    TooltipTemplateDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[nsxTooltipTemplate]'
                },] }
    ];
    /** @nocollapse */
    TooltipTemplateDirective.ctorParameters = function () { return [
        { type: TooltipService }
    ]; };
    TooltipTemplateDirective.propDecorators = {
        nsxTooltipTemplate: [{ type: Input }],
        nsxTooltipRef: [{ type: Input }]
    };
    return TooltipTemplateDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TooltipDirective = /** @class */ (function () {
    function TooltipDirective(element, renderer, viewContainer, tooltipService) {
        this.element = element;
        this.renderer = renderer;
        this.viewContainer = viewContainer;
        this.tooltipService = tooltipService;
        this.offset = 0;
        this.showDelay = 500;
        this.hideDelay = this.showDelay;
        this.tooltipId = 'nsx-tooltip-container';
        this.arrowSize = 10;
        this.onMouseover = this.show;
        this.onMouseleave = this.hide;
    }
    /**
     * @return {?}
     */
    TooltipDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.tooltipTemplate = this.tooltipService.getTooltip(this.nsxTooltipRef);
        this.tooltipRefSubscription = this.tooltipService.newTooltip$.subscribe(function () {
            _this.tooltipTemplate = _this.tooltipService.getTooltip(_this.nsxTooltipRef);
        });
    };
    /**
     * Show the html tooltip template in proper place (use X/Y from mouse event)
     * @param event Mouseenter event
     */
    /**
     * Show the html tooltip template in proper place (use X/Y from mouse event)
     * @param {?} event Mouseenter event
     * @return {?}
     */
    TooltipDirective.prototype.show = /**
     * Show the html tooltip template in proper place (use X/Y from mouse event)
     * @param {?} event Mouseenter event
     * @return {?}
     */
    function (event) {
        var _this = this;
        event.stopPropagation();
        event.preventDefault();
        if (!this.tooltipTemplate) {
            return;
        }
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
        }
        this.showTimeout = setTimeout(function () {
            _this.ishovering = true;
            _this.removeAlreadyOpenedTooltips();
            /** @type {?} */
            var element = _this.viewContainer.createEmbeddedView(_this.tooltipTemplate, { data: _this.nsxTooltipData });
            _this.tooltip = (/** @type {?} */ (((/** @type {?} */ (element))).rootNodes[0]));
            _this.generateTooltipWrapper();
            _this.generateArrowWrapper();
            _this.addTransition();
            document.body.appendChild(_this.tooltipWrapper);
            _this.setPosition((/** @type {?} */ (event)));
            _this.renderer.setStyle(_this.tooltipWrapper, 'opacity', "1");
        }, this.showDelay);
    };
    /**
     * Generates a tooltip wrapper which will have mouseleave & mouseover event listeners
     */
    /**
     * Generates a tooltip wrapper which will have mouseleave & mouseover event listeners
     * @return {?}
     */
    TooltipDirective.prototype.generateTooltipWrapper = /**
     * Generates a tooltip wrapper which will have mouseleave & mouseover event listeners
     * @return {?}
     */
    function () {
        this.tooltipWrapper = this.renderer.createElement('div');
        this.tooltipWrapper.addEventListener('mouseleave', this.hide.bind(this));
        this.tooltipWrapper.addEventListener('mouseover', this.tooltipHovering.bind(this));
        this.tooltipWrapper.id = this.tooltipId;
    };
    /**
     * Wraps provided tooltip in a div element which will have an arrow pointer
     */
    /**
     * Wraps provided tooltip in a div element which will have an arrow pointer
     * @return {?}
     */
    TooltipDirective.prototype.generateArrowWrapper = /**
     * Wraps provided tooltip in a div element which will have an arrow pointer
     * @return {?}
     */
    function () {
        /** @type {?} */
        var arrowWrapper = this.renderer.createElement('div');
        this.renderer.setStyle(arrowWrapper, 'position', 'relative');
        /** @type {?} */
        var hostElementPosition = this.element.nativeElement.getBoundingClientRect();
        /** @type {?} */
        var tooltipPosition = this.tooltip.getBoundingClientRect();
        /** @type {?} */
        var arrowElement = this.makeArrow(hostElementPosition.y > tooltipPosition.height ? 'top' : 'bottom');
        arrowWrapper.appendChild(arrowElement);
        arrowWrapper.appendChild(this.tooltip);
        this.tooltipWrapper.appendChild(arrowWrapper);
    };
    /**
     * Add transition to the tooltip (ease-in-out)
     */
    /**
     * Add transition to the tooltip (ease-in-out)
     * @return {?}
     */
    TooltipDirective.prototype.addTransition = /**
     * Add transition to the tooltip (ease-in-out)
     * @return {?}
     */
    function () {
        this.renderer.setStyle(this.tooltipWrapper, 'opacity', '0');
        this.renderer.setStyle(this.tooltipWrapper, '-webkit-transition', "opacity " + this.showDelay + "ms ease-in-out");
        this.renderer.setStyle(this.tooltipWrapper, '-moz-transition', "opacity " + this.showDelay + "ms ease-in-out");
        this.renderer.setStyle(this.tooltipWrapper, '-o-transition', "opacity " + this.showDelay + "ms ease-in-out");
        this.renderer.setStyle(this.tooltipWrapper, 'transition', "opacity " + this.showDelay + "ms ease-in-out");
    };
    /**
     * Generates a tooltip arrow eithor on top or bottom of the tooltip
     * @param side top or bottom
     */
    /**
     * Generates a tooltip arrow eithor on top or bottom of the tooltip
     * @param {?} side top or bottom
     * @return {?}
     */
    TooltipDirective.prototype.makeArrow = /**
     * Generates a tooltip arrow eithor on top or bottom of the tooltip
     * @param {?} side top or bottom
     * @return {?}
     */
    function (side) {
        /** @type {?} */
        var element = this.renderer.createElement('div');
        this.renderer.setStyle(element, 'width', '0');
        this.renderer.setStyle(element, 'height', '0');
        this.renderer.setStyle(element, 'bottom', '0');
        this.renderer.setStyle(element, 'border-left', this.arrowSize + "px solid transparent");
        this.renderer.setStyle(element, 'border-right', this.arrowSize + "px solid transparent");
        this.renderer.setStyle(element, 'z-index', '0');
        this.renderer.setStyle(element, 'left', "5px");
        this.renderer.setStyle(element, 'position', 'absolute');
        if (side === 'top') {
            this.renderer.setStyle(element, 'border-top', this.arrowSize + "px solid #d7d7d7");
            this.renderer.setStyle(element, 'bottom', "2px");
            return element;
        }
        this.renderer.setStyle(element, 'border-bottom', this.arrowSize + "px solid #d7d7d7");
        this.renderer.setStyle(element, 'top', "-" + this.arrowSize + "px");
        return element;
    };
    /**
     * Triggers whenever we are hovering in the tooltip
     */
    /**
     * Triggers whenever we are hovering in the tooltip
     * @return {?}
     */
    TooltipDirective.prototype.tooltipHovering = /**
     * Triggers whenever we are hovering in the tooltip
     * @return {?}
     */
    function () {
        clearTimeout(this.hideTimeout);
    };
    /**
     * Check if any tooltip is already opened. If so eliminate it.
     * Remember the tooltip is attached in the document's body in order to avoid css overlapping.
     * So we can have just a single tooltip opened.
     */
    /**
     * Check if any tooltip is already opened. If so eliminate it.
     * Remember the tooltip is attached in the document's body in order to avoid css overlapping.
     * So we can have just a single tooltip opened.
     * @return {?}
     */
    TooltipDirective.prototype.removeAlreadyOpenedTooltips = /**
     * Check if any tooltip is already opened. If so eliminate it.
     * Remember the tooltip is attached in the document's body in order to avoid css overlapping.
     * So we can have just a single tooltip opened.
     * @return {?}
     */
    function () {
        /** @type {?} */
        var openedTooltip = document.getElementById(this.tooltipId);
        if (openedTooltip) {
            document.body.removeChild(openedTooltip);
        }
    };
    /**
     * Hide the tooltip (if any)
     */
    /**
     * Hide the tooltip (if any)
     * @return {?}
     */
    TooltipDirective.prototype.hide = /**
     * Hide the tooltip (if any)
     * @return {?}
     */
    function () {
        var _this = this;
        clearTimeout(this.showTimeout);
        if (!this.tooltip || !this.ishovering) {
            return;
        }
        this.hideTimeout = setTimeout(function () {
            _this.ishovering = false;
            _this.renderer.setStyle(_this.tooltipWrapper, 'opacity', '0');
            //Wait for fade in/out transition to be completed
            setTimeout(_this.removeTooltipFromBody.bind(_this), _this.hideDelay);
        }, this.hideDelay);
    };
    /**
     * Remove tooltip from document along with the already attached event listeners
     */
    /**
     * Remove tooltip from document along with the already attached event listeners
     * @return {?}
     */
    TooltipDirective.prototype.removeTooltipFromBody = /**
     * Remove tooltip from document along with the already attached event listeners
     * @return {?}
     */
    function () {
        this.renderer.removeChild(document.body, this.tooltipWrapper);
        this.tooltipWrapper.removeEventListener('mouseleave', this.hide, true);
        this.tooltipWrapper.removeEventListener('mouseover', this.tooltipHovering, true);
        this.tooltipWrapper = null;
        this.viewContainer.clear();
    };
    /**
     * Sets tooltip position (verticaly & horizontaly) based to the given mouse event & window size
     * @param mouseEvent
     */
    /**
     * Sets tooltip position (verticaly & horizontaly) based to the given mouse event & window size
     * @param {?} mouseEvent
     * @return {?}
     */
    TooltipDirective.prototype.setPosition = /**
     * Sets tooltip position (verticaly & horizontaly) based to the given mouse event & window size
     * @param {?} mouseEvent
     * @return {?}
     */
    function (mouseEvent) {
        /** @type {?} */
        var hostElementPosition = this.element.nativeElement.getBoundingClientRect();
        /** @type {?} */
        var tooltipPosition = this.tooltip.getBoundingClientRect();
        /** @type {?} */
        var scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        /** @type {?} */
        var top = mouseEvent.y;
        /** @type {?} */
        var left = mouseEvent.x;
        top = this.fitToTop(hostElementPosition.y, tooltipPosition.height);
        left = this.fitToRight(left, tooltipPosition.width);
        left = left < 0 ? 0 : left;
        top = top < 0 ? 0 : top;
        this.renderer.setStyle(this.tooltipWrapper, 'top', top + scrollPos + "px");
        this.renderer.setStyle(this.tooltipWrapper, 'left', left + "px");
        this.renderer.setStyle(this.tooltipWrapper, 'position', 'absolute');
        this.renderer.setStyle(this.tooltipWrapper, 'z-index', '100');
    };
    /**
     * Fits given tooltip to the vertical axis
     * @param yPosition Vertical axis position
     * @param height tooltip height
     */
    /**
     * Fits given tooltip to the vertical axis
     * @param {?} yPosition Vertical axis position
     * @param {?} height tooltip height
     * @return {?}
     */
    TooltipDirective.prototype.fitToTop = /**
     * Fits given tooltip to the vertical axis
     * @param {?} yPosition Vertical axis position
     * @param {?} height tooltip height
     * @return {?}
     */
    function (yPosition, height) {
        /** @type {?} */
        var fits = yPosition > height;
        return fits ? yPosition - height - this.offset - this.arrowSize : yPosition + this.offset + this.arrowSize;
    };
    /**
     * Fits given tooltip to the horizontal axis
     * @param xPosition Horizontal axis position
     * @param width tooltip width
     */
    /**
     * Fits given tooltip to the horizontal axis
     * @param {?} xPosition Horizontal axis position
     * @param {?} width tooltip width
     * @return {?}
     */
    TooltipDirective.prototype.fitToRight = /**
     * Fits given tooltip to the horizontal axis
     * @param {?} xPosition Horizontal axis position
     * @param {?} width tooltip width
     * @return {?}
     */
    function (xPosition, width) {
        /** @type {?} */
        var fits = xPosition + width <= window.innerWidth;
        return fits ? xPosition : window.innerWidth - width - this.offset;
    };
    /**
     * @return {?}
     */
    TooltipDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.tooltipRefSubscription.unsubscribe();
    };
    TooltipDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[nsxTooltip]'
                },] }
    ];
    /** @nocollapse */
    TooltipDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ViewContainerRef },
        { type: TooltipService }
    ]; };
    TooltipDirective.propDecorators = {
        nsxTooltipRef: [{ type: Input }],
        nsxTooltipData: [{ type: Input }],
        offset: [{ type: Input }],
        showDelay: [{ type: Input }],
        hideDelay: [{ type: Input }],
        tooltipId: [{ type: Input }],
        arrowSize: [{ type: Input }],
        ishovering: [{ type: HostBinding, args: ['class.ngx-hovered',] }],
        onMouseover: [{ type: HostListener, args: ['mouseenter', ['$event'],] }],
        onMouseleave: [{ type: HostListener, args: ['mouseleave',] }]
    };
    return TooltipDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ApiDataBuilder = /** @class */ (function () {
    function ApiDataBuilder() {
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} pollingInterval
     * @return {THIS}
     */
    ApiDataBuilder.prototype.setPollingInterval = /**
     * @template THIS
     * @this {THIS}
     * @param {?} pollingInterval
     * @return {THIS}
     */
    function (pollingInterval) {
        (/** @type {?} */ (this)).pollingInterval = pollingInterval * 1;
        return (/** @type {?} */ (this));
    };
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} componentSelector
     * @return {THIS}
     */
    ApiDataBuilder.prototype.setComponentSelector = /**
     * @template THIS
     * @this {THIS}
     * @param {?} componentSelector
     * @return {THIS}
     */
    function (componentSelector) {
        (/** @type {?} */ (this)).componentSelector = componentSelector;
        return (/** @type {?} */ (this));
    };
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} componentType
     * @return {THIS}
     */
    ApiDataBuilder.prototype.setComponentType = /**
     * @template THIS
     * @this {THIS}
     * @param {?} componentType
     * @return {THIS}
     */
    function (componentType) {
        (/** @type {?} */ (this)).componentType = componentType;
        return (/** @type {?} */ (this));
    };
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} resolver
     * @return {THIS}
     */
    ApiDataBuilder.prototype.setApiResolver = /**
     * @template THIS
     * @this {THIS}
     * @param {?} resolver
     * @return {THIS}
     */
    function (resolver) {
        (/** @type {?} */ (this)).apiResolver = resolver;
        return (/** @type {?} */ (this));
    };
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} dispatcher
     * @return {THIS}
     */
    ApiDataBuilder.prototype.setDispatcher = /**
     * @template THIS
     * @this {THIS}
     * @param {?} dispatcher
     * @return {THIS}
     */
    function (dispatcher) {
        (/** @type {?} */ (this)).appDispatchers = dispatcher;
        return (/** @type {?} */ (this));
    };
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} selector
     * @return {THIS}
     */
    ApiDataBuilder.prototype.setSelector = /**
     * @template THIS
     * @this {THIS}
     * @param {?} selector
     * @return {THIS}
     */
    function (selector) {
        (/** @type {?} */ (this)).appSelectors = selector;
        return (/** @type {?} */ (this));
    };
    /**
     * @return {?}
     */
    ApiDataBuilder.prototype.getComponentGuid = /**
     * @return {?}
     */
    function () {
        return this.componentGuid;
    };
    /**
     * @return {?}
     */
    ApiDataBuilder.prototype.fetch = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.componentGuid = this.appDispatchers.attachComponent(this.componentSelector, this.componentType, this.pollingInterval);
        return this.appSelectors.getApiDataLatest(this.componentGuid).pipe(map(function (res) {
            /** @type {?} */
            var configuration = _this.apiResolver.resolveApiSettingsFor(_this.componentSelector, _this.componentType);
            /** @type {?} */
            var mapper = configuration.mapper.prototype.dtoToModel;
            return mapper((/** @type {?} */ (res)));
        }));
    };
    return ApiDataBuilder;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgTopNComponent = /** @class */ (function (_super) {
    __extends(NgTopNComponent, _super);
    function NgTopNComponent(appDispatchers, appSelectors, apiResolverService) {
        var _this = _super.call(this, appDispatchers) || this;
        _this.appDispatchers = appDispatchers;
        _this.appSelectors = appSelectors;
        _this.apiResolverService = apiResolverService;
        return _this;
    }
    /**
     * @return {?}
     */
    NgTopNComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var apiDataBuilder = new ApiDataBuilder();
        this.pollingSubscription = apiDataBuilder
            .setComponentSelector(topNComponentSelector)
            .setPollingInterval(this.pollingInterval)
            .setComponentType(this.type)
            .setApiResolver(this.apiResolverService)
            .setDispatcher(this.appDispatchers)
            .setSelector(this.appSelectors)
            .fetch()
            .subscribe(function (res) {
            _this.items = res;
            _this.sortItems();
            _this.keepNItems();
            _this.calculateValuePercentages();
        });
        this.componentGuid = apiDataBuilder.getComponentGuid();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgTopNComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.items) {
            this.sortItems();
            this.calculateValuePercentages();
            console.log('calculating');
        }
    };
    /**
     * @return {?}
     */
    NgTopNComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.pollingSubscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    NgTopNComponent.prototype.calculateValuePercentages = /**
     * @return {?}
     */
    function () {
        var e_1, _a;
        if (!this.items || !this.items.length) {
            return;
        }
        /** @type {?} */
        var maxValue = this.items[0].value;
        try {
            for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                item.percentage = (item.value * 100 / maxValue) + '%';
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * @return {?}
     */
    NgTopNComponent.prototype.sortItems = /**
     * @return {?}
     */
    function () {
        this.items.sort(function (a, b) { return b.value - a.value; });
    };
    /**
     * @return {?}
     */
    NgTopNComponent.prototype.keepNItems = /**
     * @return {?}
     */
    function () {
        if (this.size) {
            this.items.splice(this.size);
        }
    };
    /**
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    NgTopNComponent.prototype.itemIdentify = /**
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    function (index, item) {
        return item.title;
    };
    NgTopNComponent.decorators = [
        { type: Component, args: [{
                    selector: topNComponentSelector,
                    template: "\n  <ng-template>\n    <div class=\"top-n-component\">\n      <lib-top-n-header [title]=\"title\"></lib-top-n-header>\n      <div class=\"total-items\">\n        <lib-top-n-item \n        *ngFor=\"let item of items;trackBy: itemIdentify\" \n        [item]=\"item\"\n        [tooltipRef]=\"tooltipRef\"></lib-top-n-item>\n      </div>\n    </div>\n  </ng-template>\n  ",
                    styles: ["::ng-deep .total-items lib-top-n-item:first-child .item{border-top-left-radius:5px;border-top-right-radius:5px}::ng-deep .total-items lib-top-n-item:last-child .item{border-bottom-left-radius:5px;border-bottom-right-radius:5px}"]
                }] }
    ];
    /** @nocollapse */
    NgTopNComponent.ctorParameters = function () { return [
        { type: AppDispatchers },
        { type: AppSelectors },
        { type: ApiResolverService }
    ]; };
    NgTopNComponent.propDecorators = {
        type: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        isSelected: [{ type: Input }],
        tooltipRef: [{ type: Input }]
    };
    return NgTopNComponent;
}(NsxUiComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TopNHeaderComponent = /** @class */ (function () {
    function TopNHeaderComponent() {
    }
    /**
     * @return {?}
     */
    TopNHeaderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    TopNHeaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-top-n-header',
                    template: "\n    <span class=\"title\" [innerText]=\"title\"></span>\n  ",
                    styles: [".title{color:#656565;display:flex;text-align:left;line-height:18px;font-size:10px;font-weight:700;padding-left:12px}"]
                }] }
    ];
    /** @nocollapse */
    TopNHeaderComponent.ctorParameters = function () { return []; };
    TopNHeaderComponent.propDecorators = {
        title: [{ type: Input }]
    };
    return TopNHeaderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UiEventService = /** @class */ (function () {
    function UiEventService() {
        // Observable string sources
        this.uiEventSubject = new Subject();
        // Observable string streams
        this.uiEvent$ = this.uiEventSubject.asObservable();
    }
    /**
     * @param {?} type
     * @return {?}
     */
    UiEventService.prototype.uiEventByType = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        return this.uiEvent$.pipe(filter(function (e) {
            return e.type === type;
        }));
    };
    /**
     * @param {?} type
     * @param {?} feature
     * @return {?}
     */
    UiEventService.prototype.uiEventByFeatureAndType = /**
     * @param {?} type
     * @param {?} feature
     * @return {?}
     */
    function (type, feature) {
        return this.uiEvent$.pipe(filter(function (e) { return e.type === type && e.feature === feature; }));
    };
    // Service message commands
    // Service message commands
    /**
     * @template T
     * @param {?} event
     * @return {?}
     */
    UiEventService.prototype.emitEvent = 
    // Service message commands
    /**
     * @template T
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.uiEventSubject.next(event);
    };
    UiEventService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ UiEventService.ngInjectableDef = defineInjectable({ factory: function UiEventService_Factory() { return new UiEventService(); }, token: UiEventService, providedIn: "root" });
    return UiEventService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Hoverable = /** @class */ (function () {
    function Hoverable() {
    }
    return Hoverable;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TopNItemComponent = /** @class */ (function (_super) {
    __extends(TopNItemComponent, _super);
    function TopNItemComponent(eventService) {
        var _this = _super.call(this) || this;
        _this.eventService = eventService;
        _this.tooltipRef = _this.tooltipRef;
        return _this;
    }
    /**
     * @return {?}
     */
    TopNItemComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    TopNItemComponent.prototype.sendUiEvent = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var event = {
            type: 'click',
            feature: 'lib-top-n-item',
            data: this.item
        };
        this.eventService.emitEvent(event);
    };
    TopNItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-top-n-item',
                    template: "<div class=\"item\" (click)=\"sendUiEvent()\" nsxTooltip [nsxTooltipRef]=\"tooltipRef\" [nsxTooltipData]=\"item\">\n  <div class=\"item-title\">\n    <div class=\"item-title_progress\" [style.width]=\"item.percentage\">\n      <div>{{item.title}}</div>\n    </div>\n  </div>\n  <div class=\"item-value\">{{item.value}} %</div>\n</div>\n",
                    styles: [".item{font-family:Metropolis;display:flex;background-color:#fff;padding:3px 0;margin:2px;justify-content:space-between;cursor:pointer}.item-title{display:flex;line-height:18px;font-size:11px;text-indent:8px;color:#007cbb;padding-left:10px;width:50%;flex-grow:12}.item-title_progress{background-color:#f0f0f0;height:18px;position:relative;border-radius:13px;text-align:left}.item-title_progress div{line-height:18px;white-space:nowrap}.item-value{line-height:18px;font-size:10px;flex:auto}"]
                }] }
    ];
    /** @nocollapse */
    TopNItemComponent.ctorParameters = function () { return [
        { type: UiEventService }
    ]; };
    TopNItemComponent.propDecorators = {
        item: [{ type: Input }],
        tooltipRef: [{ type: Input }]
    };
    return TopNItemComponent;
}(Hoverable));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CarouselItemElement = /** @class */ (function () {
    function CarouselItemElement() {
    }
    CarouselItemElement.decorators = [
        { type: Directive, args: [{
                    selector: '.carousel-item'
                },] }
    ];
    return CarouselItemElement;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// import { StorageService } from '@libs/services';
// import { UserPreferencesService } from '@app/services';
var CarouselComponent = /** @class */ (function () {
    function CarouselComponent(builder) {
        var _this = this;
        this.builder = builder;
        this.carouselWrapperStyle = {};
        this.itemHeight = 0;
        this.showNavigationIcon = true;
        this.currentSlide = 0;
        this.LIMIT_PAGE_RENDERED = 1;
        this.calculationDone = false;
        this.timing = '0.2s ease-in-out';
        this.showControls = true;
        this.itemsPerPage = 1;
        this.slideChange = new EventEmitter();
        this.subscriptions = [];
        this.resizeCarouselFromMenu = function (open) {
            /** @type {?} */
            var carouselWidth = _this.carousel.nativeElement.parentNode.parentNode.getBoundingClientRect().width;
            _this.itemWidth = carouselWidth / _this.itemsPerPage + (227 * (open ? -1 : 1)) / _this.itemsPerPage; // 227 menu diff on close open.
            _this.carouselWrapperStyle = {
                width: _this.itemWidth + "px"
            };
            _this.goToSlide(_this.currentSlide, undefined, true);
        };
        this.initCarousel = function () {
            /** @type {?} */
            var carouselWidth = _this.carousel.nativeElement.parentNode.parentNode.getBoundingClientRect().width;
            _this.itemWidth = carouselWidth / _this.itemsPerPage;
            _this.carouselWrapperStyle = {
                width: _this.itemWidth + "px"
            };
            if (_this.timeout) {
                clearTimeout(_this.timeout);
            }
            _this.timeout = setTimeout(function () {
                /** @type {?} */
                var offset = _this.currentSlide * _this.itemWidth * _this.itemsPerPage;
                _this.animation('0s ease-in-out', offset);
                _this.calculationDone = true;
                _this.slideChange.emit(_this.currentSlide);
                _this.evaluateItemsVisibility();
            }, 1);
        };
        this.slideChanger = function () {
            _this.slideChange.emit(_this.currentSlide);
            // this.setOrUpdateCarouselPref(this.currentSlide);
            /** @type {?} */
            var offset = _this.currentSlide * _this.itemWidth * _this.itemsPerPage;
            _this.animation(_this.timing, offset);
        };
    }
    /**
     * @return {?}
     */
    CarouselComponent.prototype.onResize = /**
     * @return {?}
     */
    function () {
        this.initCarousel();
    };
    /**
     * @return {?}
     */
    CarouselComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initCarousel();
        this.pages = Array(this.noOfPages);
    };
    /**
     * @return {?}
     */
    CarouselComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        console.log(this.items[0]);
    };
    /**
     * @return {?}
     */
    CarouselComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        // this.eventsService.removeListener('sidenav-collapsed-start', this.resizeCarouselFromMenu);
        // Removing this as arrows should always appear on the Carousel, NAU-27
        // this.eventsService.removeListener('data-clicked', this.showOrHideNavigation);
    };
    /**
     * @return {?}
     */
    CarouselComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        this.pages = Array(this.noOfPages);
    };
    /**
     * @param {?} slideNumber
     * @param {?=} $event
     * @param {?=} forced
     * @return {?}
     */
    CarouselComponent.prototype.goToSlide = /**
     * @param {?} slideNumber
     * @param {?=} $event
     * @param {?=} forced
     * @return {?}
     */
    function (slideNumber, $event, forced) {
        if ($event === void 0) { $event = undefined; }
        if (!forced && this.currentSlide === slideNumber) {
            return;
        }
        if (this.currentSlide > slideNumber) {
            this.goBack($event, slideNumber, false);
        }
        else {
            this.goForward($event, slideNumber, false);
        }
    };
    /**
     * @param {?} $event
     * @param {?=} slideNumber
     * @param {?=} isNext
     * @return {?}
     */
    CarouselComponent.prototype.goForward = /**
     * @param {?} $event
     * @param {?=} slideNumber
     * @param {?=} isNext
     * @return {?}
     */
    function ($event, slideNumber, isNext) {
        if (slideNumber === void 0) { slideNumber = 1; }
        if (isNext === void 0) { isNext = true; }
        if (this.currentSlide === this.noOfPages) {
            this.currentSlide = 0;
        }
        this.currentSlide = isNext ? ((this.currentSlide + slideNumber) + this.noOfPages) % this.noOfPages : slideNumber;
        this.slideChanger();
        this.evaluateItemsVisibility();
    };
    /**
     * @param {?} $event
     * @param {?=} slideNumber
     * @param {?=} isPrevious
     * @return {?}
     */
    CarouselComponent.prototype.goBack = /**
     * @param {?} $event
     * @param {?=} slideNumber
     * @param {?=} isPrevious
     * @return {?}
     */
    function ($event, slideNumber, isPrevious) {
        if (slideNumber === void 0) { slideNumber = 1; }
        if (isPrevious === void 0) { isPrevious = true; }
        if (this.currentSlide === 0) {
            this.currentSlide = this.noOfPages;
        }
        this.currentSlide = isPrevious ? ((this.currentSlide - slideNumber) + this.noOfPages) % this.noOfPages : slideNumber;
        this.slideChanger();
        this.evaluateItemsVisibility();
    };
    /**
     * @private
     * @return {?}
     */
    CarouselComponent.prototype.evaluateItemsVisibility = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout(function () {
            _this.carouselItems.toArray().forEach(function (i, index) {
                /** @type {?} */
                var carouselBoundaries = _this.carouselWrapper.nativeElement.getBoundingClientRect();
                /** @type {?} */
                var carouselLeftBoundary = carouselBoundaries.x;
                /** @type {?} */
                var carouselRightBoundary = carouselLeftBoundary + carouselBoundaries.width;
                /** @type {?} */
                var itemLeftBoundary = i.nativeElement.getBoundingClientRect().x;
                /** @type {?} */
                var uiComponent = _this.items.toArray()[index];
                /** @type {?} */
                var visibility = itemLeftBoundary >= carouselLeftBoundary && itemLeftBoundary < carouselRightBoundary;
                uiComponent.setVisibility(visibility);
            });
        }, 1500);
    };
    /**
     * @private
     * @param {?} timing
     * @param {?} offset
     * @return {?}
     */
    CarouselComponent.prototype.animation = /**
     * @private
     * @param {?} timing
     * @param {?} offset
     * @return {?}
     */
    function (timing, offset) {
        /** @type {?} */
        var myAnimation = this.builder.build([
            animate(timing, style({ transform: "translateX(-" + offset + "px)" }))
        ]);
        this.player = myAnimation.create(this.carousel.nativeElement);
        this.player.play();
    };
    CarouselComponent.decorators = [
        { type: Component, args: [{
                    selector: 'carousel',
                    exportAs: 'carousel',
                    template: "<div class=\"carousel\" #carouselWrapper>\n  <div class=\"carousel-title\">\n    {{name}}\n  </div>\n  <clr-icon class=\"carousel-caret left\" shape=\"caret left\" *ngIf=\"noOfPages > 1\" (click)=\"goBack($event)\"></clr-icon>\n  <section class=\"carousel-wrapper\">\n    <ul class=\"carousel-inner\" #carousel>\n      <li class=\"carousel-item\" [ngStyle]=\"carouselWrapperStyle\" *ngFor=\"let item of items; let i = index\" #carouselItem>\n        <ng-container [ngTemplateOutlet]=\"item.tpl\" *ngIf=\"calculationDone && currentSlide * itemsPerPage + LIMIT_PAGE_RENDERED * itemsPerPage >= i && currentSlide * itemsPerPage - LIMIT_PAGE_RENDERED * itemsPerPage <= i\"></ng-container>\n      </li>\n    </ul>\n  </section>\n  <clr-icon class=\"carousel-caret right\" shape=\"caret right\" *ngIf=\"noOfPages > 1\" (click)=\"goForward($event)\"></clr-icon>\n  <div class=\"carousel-controls\">\n    <div class=\"carousel-controls-item\" [ngClass]=\"{'active': i === currentSlide}\" [attr.data-index]=\"i\"\n      *ngFor=\"let page of pages; let i = index\">\n    </div>\n  </div>\n</div>",
                    styles: [".carousel{position:relative;padding:0;list-style:none;background-color:#f8f8f8;border-radius:7px;margin:0;font-family:Metropolis}.carousel-title{line-height:18px;font-size:18px;text-align:left;color:#565656;margin-bottom:10px}.carousel-wrapper{height:100%;width:100%;display:flex;flex-direction:row;justify-content:space-between;flex:1;overflow:hidden}.carousel-caret{position:absolute;top:50%;height:38px;width:38px;color:rgba(0,0,0,.35);background-color:none;cursor:pointer;display:flex;flex-shrink:0;z-index:4}.carousel-caret:hover{color:#000}.carousel-caret.left{left:-35px}.carousel-caret.right{right:-35px}.carousel-inner{display:flex;list-style:none}.carousel-item{height:100%;width:100%;list-style-type:none;transition:width .2s ease-in-out}.carousel-controls{position:relative;display:flex;width:100%;justify-content:center;align-items:center;top:10px}.carousel-controls-item{margin:0 4px;width:30px;height:2px;flex-direction:row;background-color:#adadad}.carousel-controls-item.active{height:3px;background-color:gray}.hide-slide-content{visibility:hidden}.dark .carousel-caret{color:rgba(128,128,128,.35);background-color:none}.dark .carousel-caret:hover{color:gray}.dark .carousel-controls-item{background-color:#adadad;margin:4px}.dark .carousel-controls-item.active,.dark .carousel-controls-item:hover{background-color:gray}"]
                }] }
    ];
    /** @nocollapse */
    CarouselComponent.ctorParameters = function () { return [
        { type: AnimationBuilder }
    ]; };
    CarouselComponent.propDecorators = {
        timing: [{ type: Input }],
        showControls: [{ type: Input }],
        showPreview: [{ type: Input }],
        itemsPerPage: [{ type: Input }],
        noOfPages: [{ type: Input }],
        name: [{ type: Input }],
        slideChange: [{ type: Output }],
        items: [{ type: ContentChildren, args: ['uiComponent',] }],
        itemsElements: [{ type: ViewChildren, args: [CarouselItemElement, { read: ElementRef },] }],
        carousel: [{ type: ViewChild, args: ['carousel',] }],
        carouselItems: [{ type: ViewChildren, args: ['carouselItem',] }],
        carouselWrapper: [{ type: ViewChild, args: ['carouselWrapper',] }],
        onResize: [{ type: HostListener, args: ['window:resize',] }]
    };
    return CarouselComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NsxUiLibModule = /** @class */ (function () {
    function NsxUiLibModule() {
    }
    NsxUiLibModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        NgTopNComponent,
                        TopNHeaderComponent,
                        TopNItemComponent,
                        CarouselComponent,
                        CarouselItemElement,
                        TooltipDirective,
                        TooltipTemplateDirective
                    ],
                    imports: [
                        BrowserModule,
                        CommonModule,
                        ClarityModule,
                        ApiResolverModule,
                        BrowserAnimationsModule,
                        EffectsModule.forFeature([NsxUiEffects])
                    ],
                    providers: [AppDispatchers, AppSelectors, TooltipService],
                    exports: [NgTopNComponent, CarouselComponent, TooltipDirective, TooltipTemplateDirective]
                },] }
    ];
    return NsxUiLibModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NsxApiComponent, NsxUiComponent, TooltipTemplateDirective, TooltipDirective, NgTopNComponent, TopNHeaderComponent, TopNItemComponent, CarouselComponent, CarouselItemElement, NsxUiLibModule, UiEventService, Hoverable as ɵb, TooltipService as ɵa };

//# sourceMappingURL=kissmybutton-nsx-ui-lib.js.map